import * as React from 'react';
import { ITimeZoneProps } from './types';
import { v4 as uuidv4 } from 'uuid';
import { TIMEZONE_MORE_INSTRUCTIONS, TIMEZONE_TEXT } from '../../constants';
import { BOARD_DETAILS_ONLY_OWNER, CLASS_BOARD_DETAILS } from '../../../../constants';
import './_TimeZone.scss';
import { TimeZoneOption } from '../TimeZoneOption/TimeZoneOption';
import { SearchSelect } from '../../../../../../base/components/SearchSelect/SearchSelect';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`TimeZone`) : null;

export function TimeZone ({
    text,
    value,
    options,
    isDisabled,
    onShowBoardLimitSnackbarIfNeeded,
    onClickLink,
    onChange
}: ITimeZoneProps){
    if (analyzeRender) analyzeRender.call(`TimeZone`);
    const [key, setKey] = React.useState(uuidv4());
    const classText = CLASS_BOARD_DETAILS + '__timezone-text';
    const classDropdown = CLASS_BOARD_DETAILS + '__timezone-dropdown';

    function onClose() {
        setKey(uuidv4())
    }

    return (
        <div>
            <div className={classText}>
                {TIMEZONE_TEXT} <a onClick={onClickLink} href="https://www.kanbanchi.com/faqwd/kanbanchi-time-zones" target="_blank">{TIMEZONE_MORE_INSTRUCTIONS}</a>
                {isDisabled && <p>{BOARD_DETAILS_ONLY_OWNER}</p>}
            </div>
            <div className={CLASS_BOARD_DETAILS + '__timezone-wrapper'} onClick={onShowBoardLimitSnackbarIfNeeded}>
                <SearchSelect
                    activeValue={value}
                    directionVertical={'auto'}
                    disabled={isDisabled}
                    dropdownClassName={classDropdown}
                    key={key}
                    option={TimeZoneOption}
                    options={options}
                    text={text}
                    variant={'arrow'}
                    onClosed={onClose}
                    onSelect={onChange}
                />
            </div>
        </div>
    );
}
